import { render, staticRenderFns } from "./UpdatesSchedule.vue?vue&type=template&id=18801610&scoped=true&"
import script from "./UpdatesSchedule.vue?vue&type=script&lang=js&"
export * from "./UpdatesSchedule.vue?vue&type=script&lang=js&"
import style0 from "./UpdatesSchedule.vue?vue&type=style&index=0&id=18801610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18801610",
  null
  
)

export default component.exports